import { Chart, ChartFooterChard, Typography, colors, IconGraphy } from '@leapeasy/ui-kit';
import { Box } from '@mui/material';

export const ExpiringPoliciesChart = ({ data, onClickItem }) => {
  const expiringLt30Count = Number(data?.expiringLt30Count) || 0;
  const expiring31_60Count = Number(data?.expiring31_60Count) || 0;
  const expiring61_90Count = Number(data?.expiring61_90Count) || 0;
  const expiring91_120Count = Number(data?.expiring91_120Count) || 0;

  return (
    <Chart
      variant="bar"
      data={[
        {
          name: '30 days',
          value: expiringLt30Count,
        },
        {
          name: '60 days',
          value: expiring31_60Count,
        },
        {
          name: '90 days',
          value: expiring61_90Count,
        },
        {
          name: '120 days',
          value: expiring91_120Count,
        },
      ]}
      colors={{
        value: colors.magentaRed[100],
      }}
      title="Expiring Policies"
      description="Here is an overview of policies expiring within the next 30,60, 90, and 120 days."
      chartWidth="100%"
      containerStyles={{ width: '100%' }}
      bodyStyles={{ background: 'white', border: 'none', boxShadow: 'unset' }}
      icon={<IconGraphy icon="FileFolder.RequestQuoteDollar" />}
      footer={
        <Box
          sx={{
            gap: '16px',
            width: '100%',
            display: 'flex',
            '& > *': { flexGrow: 1 },
          }}
        >
          <ChartFooterChard
            backgroundColor="#F9F8F9"
            activeColor={colors.magentaRed[200]}
            title={
              <Box sx={{ px: 1, py: 2 }}>
                <IconGraphy
                  icon="FileFolder.PendingActions"
                  color={colors.magentaRed[200]}
                  style={{ width: '20px', height: '20px' }}
                />
              </Box>
            }
            content={
              <Box sx={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
                <Typography variant="h4" style={{ fontWeight: '500', color: colors.purple[900] }}>
                  {expiringLt30Count.toLocaleString()}
                </Typography>

                <Typography
                  variant="small"
                  style={{ fontWeight: '500', color: colors.neutral[900] }}
                >
                  {'<'} 30 Days
                </Typography>
              </Box>
            }
            onClick={() => onClickItem('expiring_lt_30')}
          />

          <ChartFooterChard
            backgroundColor="#F9F8F9"
            activeColor={colors.magentaRed[200]}
            title={
              <Box sx={{ px: 1, py: 2 }}>
                <IconGraphy
                  icon="FileFolder.PendingActions"
                  color={colors.magentaRed[200]}
                  style={{ width: '20px', height: '20px' }}
                />
              </Box>
            }
            content={
              <Box style={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
                <Typography variant="h4" style={{ fontWeight: '500', color: colors.purple[900] }}>
                  {expiring31_60Count.toLocaleString()}
                </Typography>

                <Typography
                  variant="small"
                  style={{ fontWeight: '500', color: colors.purple[900] }}
                >
                  31 ~ 60 Days
                </Typography>
              </Box>
            }
            onClick={() => onClickItem('expiring_31_60')}
          />

          <ChartFooterChard
            backgroundColor="#F9F8F9"
            activeColor={colors.magentaRed[200]}
            title={
              <Box sx={{ px: 1, py: 2 }}>
                <IconGraphy
                  icon="FileFolder.PendingActions"
                  color={colors.magentaRed[200]}
                  style={{ width: '20px', height: '20px' }}
                />
              </Box>
            }
            content={
              <Box style={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
                <Typography variant="h4" style={{ fontWeight: '500', color: colors.purple[900] }}>
                  {expiring61_90Count.toLocaleString()}
                </Typography>

                <Typography
                  variant="small"
                  style={{ fontWeight: '500', color: colors.neutral[900] }}
                >
                  61 ~ 90 Days
                </Typography>
              </Box>
            }
            onClick={() => onClickItem('expiring_61_90')}
          />

          <ChartFooterChard
            backgroundColor="#F9F8F9"
            activeColor={colors.magentaRed[200]}
            title={
              <Box sx={{ px: 1, py: 2 }}>
                <IconGraphy
                  icon="FileFolder.PendingActions"
                  color={colors.magentaRed[200]}
                  style={{ width: '20px', height: '20px' }}
                />
              </Box>
            }
            content={
              <Box style={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
                <Typography variant="h4" style={{ fontWeight: '500', color: colors.purple[900] }}>
                  {expiring91_120Count.toLocaleString()}
                </Typography>

                <Typography
                  variant="small"
                  style={{ fontWeight: '500', color: colors.neutral[900] }}
                >
                  91 ~ 120 Days
                </Typography>
              </Box>
            }
            onClick={() => onClickItem('expiring_91_120')}
          />
        </Box>
      }
    />
  );
};
